import styled, { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { colours, fonts } from 'themes/default';
import { BREAKPOINTS } from 'constants/breakpoints';
const { fontFamily, fontStyleRegular, htmlSizeReset, baseSize } = fonts;

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  html {
    ${htmlSizeReset}
  }

  body {
    font-family: ${fontFamily};
    font-size: ${baseSize};
    margin: 0;
  }
  
  h1 {
    ${fonts.FunctionalHeadingXL}
  }
  
  h2 {
    ${fonts.FunctionalHeadingL}
  }
  
  h3 {
    ${fonts.FunctionalHeadingM}
  }
  
  h4 {
    ${fonts.FunctionalHeadingM}
  }
  
  p {
    ${fonts.BodyM}
  }
`;

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const Main = styled('main')`
  padding-top: 76.78px;
  background-color: ${colours.Greyscale.Eggshell};
  display: flex;
  flex-direction: column;
  ${fontStyleRegular};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: relative;
    padding: 0px;
  }
`;
